import React from 'react';

import './Introduction.css'

const Introduction = () => {
  return (
    <div className='intro'>
      <h3>🤓 About Lendify</h3>
      <p>
        Lendify is a decentralized, blockchain-based platform that enables users to securely and transparently borrow and lend money to each other. Our platform uses smart contracts and machine learning algorithms to automate the loan application, approval, and repayment processes, making it fast and easy for users to access loans and earn interest on their savings.
      </p>
    </div>
  );
};

export default Introduction;
